// The tags down the side of a list of posts, commonest first, each a filter.
import { Link } from "wouter";

const label = "mb-2 font-sans text-[11px] tracking-[0.1em] text-ink-3 uppercase";

export function TagList({
  title,
  tags,
  current,
  href,
}: {
  title: string;
  tags: [string, number][];
  current: string | null;
  href: (tag: string) => string;
}) {
  if (!tags.length) return null;
  return (
    <div>
      <p className={label}>{title}</p>
      <ul className="space-y-1 font-sans text-[13.5px]">
        {tags.map(([t, n]) => (
          <li key={t}>
            <Link href={href(t)} className={`flex justify-between ${t === current ? "text-accent" : "text-ink-2 hover:text-ink"}`}>
              {t} <span className="text-ink-3 tabular-nums">{n}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
